import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "md:my-14 mt-5 grid gap-y-5 p-2" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "bg-white rounded-lg border border-gray-300" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Table = _resolveComponent("Table")!
  const _component_EmptyData = _resolveComponent("EmptyData")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_Loader, { loader: _ctx.pageLoader }, null, 8, ["loader"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", null, _toDisplayString(_ctx.$t("labels.generic", { pt: "Turmas", en: "Classes" })), 1),
      (_ctx.user?.role === 'ADMINISTRATOR')
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            label: 
          _ctx.$t('labels.generic', { pt: 'Adicionar turma', en: 'Add class' })
        ,
            class: "btn-primary p-button-sm",
            icon: "pi pi-plus",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.go.redirectToPage('formClasses', { tab: 0 })))
          }, null, 8, ["label"]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.pageLoader)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_ctx.classes?.length !== 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_Table, {
                    slotData: _ctx.classes,
                    columns: _ctx.columns,
                    actions: _ctx.actions,
                    loading: _ctx.loading,
                    filters: _ctx.filters,
                    hasStatus: true,
                    params: _ctx.params,
                    hasActions: _ctx.user?.role ==='ADMINISTRATOR',
                    onOnFilter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.filterFor())),
                    onOnClearFilter: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clearFilter())),
                    onOnToggleFilter: _cache[4] || (_cache[4] = (e, type) => _ctx.toggleFilter(e, type)),
                    onOnEdit: _cache[5] || (_cache[5] = (e) => _ctx.goTo(e)),
                    onOnChangeStatus: _cache[6] || (_cache[6] = (e) => _ctx.confirmModal(e)),
                    onOnPaginate: _cache[7] || (_cache[7] = ($event: any) => (_ctx.paginate($event)))
                  }, {
                    filters: _withCtx(() => [
                      (_ctx.filterType === 'name')
                        ? (_openBlock(), _createBlock(_component_InputText, {
                            key: 0,
                            modelValue: _ctx.filters.name,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.name) = $event))
                          }, null, 8, ["modelValue"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["slotData", "columns", "actions", "loading", "filters", "params", "hasActions"])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.loading && _ctx.classes && _ctx.classes.length === 0)
      ? (_openBlock(), _createBlock(_component_EmptyData, {
          key: 1,
          data: !_ctx.classes || _ctx.classes.length == 0,
          label: _ctx.emptyState.description,
          image: _ctx.emptyState.image,
          imgSize: "h-40 md:h-64 mt-20",
          msgSize: "md:w-3/12"
        }, null, 8, ["data", "label", "image"]))
      : _createCommentVNode("", true),
    _createVNode(_component_ConfirmDialog, { style: { width: '80vw', maxWidth: '700px' } })
  ]))
}